// ============================================
// SELLOAUTORIA.JS — "quien lo creo y quien lo toco por ultima vez"
// ============================================
// POR QUE EXISTE (AUTORIA-CLIENTES, 2026-09-18)
// Ninguna tabla de clientes guardaba autor: solo fecha. Ricardo lo pidio como dato de OPERACION,
// no de auditoria: "hoy tampoco puedo saber cual de mi equipo cambio un dato de un cliente".
// La columna sola no sirve de nada si no llega a la pantalla; esto es la pantalla.
//
// LO VIEJO SE DICE "desconocido", NO SE INVENTA. Las filas anteriores a la migracion 087 tienen el
// autor en NULL, y eso es informacion de verdad: "de antes de que esto se midiera". Nunca se
// atribuye a nadie por defecto.

import React from 'react';
import { PP, COLOR_GRIS_CLARO, COLOR_BORDE } from './helpersClientes';

// "18 sep 2026, 14:32". Devuelve null si no hay fecha utilizable.
function cuando(valor) {
  if (!valor) return null;
  const d = new Date(valor);
  if (isNaN(d)) return null;
  return d.toLocaleString('es-MX', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

function Linea({ etiqueta, quien, fecha }) {
  const f = cuando(fecha);
  if (!quien && !f) return null;
  return (
    <span>
      {etiqueta}{' '}
      <strong style={{ fontWeight: 600 }}>{quien || 'alguien desconocido'}</strong>
      {f ? <> · {f}</> : null}
    </span>
  );
}

/**
 * Pie de ficha con la autoria. Se le pasa la entidad tal cual la devuelve el backend.
 * Campos que espera: creado_por_nombre, creado_en|creado_at, actualizado_por_nombre,
 * actualizado_en|actualizado_at.
 */
export default function SelloAutoria({ entidad, estilo }) {
  if (!entidad) return null;
  const creadoEn = entidad.creado_en || entidad.creado_at;
  const editadoEn = entidad.actualizado_en || entidad.actualizado_at;

  // Si no hay NI fecha NI autor por ningun lado, no se pinta un pie vacio.
  if (!creadoEn && !editadoEn && !entidad.creado_por_nombre && !entidad.actualizado_por_nombre) return null;

  // Cuando el alta y la ultima edicion son la misma cosa (nadie lo ha tocado desde que se creo),
  // repetir la linea seria ruido. Se enseña una sola.
  const mismoMomento = creadoEn && editadoEn
    && Math.abs(new Date(editadoEn) - new Date(creadoEn)) < 60000
    && (entidad.creado_por_nombre || null) === (entidad.actualizado_por_nombre || null);

  return (
    <div style={{
      fontFamily: PP, fontSize: 11, color: COLOR_GRIS_CLARO, lineHeight: 1.7,
      borderTop: `1px solid ${COLOR_BORDE}`, paddingTop: 10, marginTop: 4,
      display: 'flex', flexWrap: 'wrap', gap: '2px 14px',
      ...estilo,
    }}>
      <Linea etiqueta="Creado por" quien={entidad.creado_por_nombre} fecha={creadoEn} />
      {!mismoMomento && (
        <Linea etiqueta="Última modificación:" quien={entidad.actualizado_por_nombre} fecha={editadoEn} />
      )}
    </div>
  );
}
